import React from 'react'
import { StyledLinearGradient, StyledModal, StyledModalWrapper, StyledOomphModal } from './style'

interface OomphModalProps {
  children: React.ReactNode
}

const OomphModal = ({ children }: OomphModalProps) => {
  return (
    <StyledOomphModal>
      <StyledLinearGradient start={{ x: 1, y: 0 }} end={{ x: 0, y: 1 }}>
        {children}
      </StyledLinearGradient>
    </StyledOomphModal>
  )
}

export interface ModalProps {
  children: React.ReactNode
  variant?: string
}

const Modal = ({ children, variant }: ModalProps) => {
  return (
    <StyledModalWrapper>
      {variant === 'oomph' ? (
        <OomphModal>{children}</OomphModal>
      ) : (
        <StyledModal>{children}</StyledModal>
      )}
    </StyledModalWrapper>
  )
}

export default Modal
